export const CommonValidationLabels = {
    firstName: { english: 'First name', spanish: 'Nombre' },
    lastName: { english: 'Last name', spanish: 'Apellido' },
    dateOfBirth: { english: 'Date of birth', spanish: 'Fecha de nacimiento' },
    lastFourSSN: { english: 'Last 4 SSN', spanish: 'Últimos 4 dígitos del SSN' },
    phoneNumber: { english: 'Phone number', spanish: 'Número de teléfono' },
    email: { english: 'Email address', spanish: 'Dirección de correo electrónico' },
    claimLeaveNumber: { english: 'Claim/leave number', spanish: 'Número de reclamo/licencia' },
    timeZone: { english: 'Time zone', spanish: 'Zona horaria' },
    preferredPhone: { english: 'Preferred phone number', spanish: 'Número de teléfono preferido' },
    preferredEmail: { english: 'Preferred email address', spanish: 'Dirección de correo electrónico preferida' },
    reEnterPreferredEmail: { english: 'Re-enter preferred email address', spanish: 'Vuelva a ingresar la dirección de correo electrónico preferida' },
};
